import myCartReducer from './cartReducer';
import courseExplorerReducer from './courseExplorerReducer';
import spinnerLoadingReducer from './spinnerReducer';
import userInfoReducer from './userInfoReducer';

export { myCartReducer, courseExplorerReducer, spinnerLoadingReducer, userInfoReducer };